import { defineComponent, h } from 'vue'
import { mdi as baseMdiSet, aliases as baseAliases } from 'vuetify/iconsets/mdi-svg'
import * as MDI from '@mdi/js'

// Utilidad: convertir 'mdi-office-building' -> 'mdiOfficeBuilding'
function mdiKebabToExport(name: string) {
  if (!name || !name.startsWith('mdi-')) return name
  const rest = name.slice(4)
  const camel = rest.replace(/-([a-z0-9])/g, (_: string, c: string) => c.toUpperCase())
  return 'mdi' + camel.charAt(0).toUpperCase() + camel.slice(1)
}

function resolveIconValue(value: any) {
  if (typeof value === 'string') {
    // Alias de Vuetify (p.ej. $close) -> dejar al parser de Vuetify
    if (value.startsWith('$')) return value
    // Soportar referencias con prefijo de set 'mdi:<name>' resolviéndolas a path
    if (/^mdi:[a-z0-9-]+$/i.test(value)) {
      const name = value.slice(4)
      const exportName = mdiKebabToExport('mdi-' + name)
      const path = (MDI as any)[exportName]
      if (typeof path === 'string') return path
      // Fallback: devolver string vacío para evitar error en atributo d
      return ''
    }
    // Si es nombre mdi-*, mapear a path
    if (value.startsWith('mdi-')) {
      const exportName = mdiKebabToExport(value)
      const path = (MDI as any)[exportName]
      if (typeof path === 'string') return path
      return ''
    }
    // Si es un nombre simple (por venir ya separado por set 'mdi:<name>'), resolver como mdi-<name>
    if (/^[a-z0-9-]+$/i.test(value)) {
      const exportName = mdiKebabToExport('mdi-' + value)
      const path = (MDI as any)[exportName]
      if (typeof path === 'string') return path
      return ''
    }
  }
  return value
}

// Envolver el componente del set MDI SVG de Vuetify para normalizar cualquier string 'mdi-*'
const MdiSvgCompat = defineComponent({
  name: 'MdiSvgCompat',
  // Reusar las props del componente original para evitar desajustes
  props: (baseMdiSet as any).component.props,
  setup(props, { attrs, slots }) {
    const Original = (baseMdiSet as any).component
    return () => {
      const p: any = props
      const normalizedIcon = resolveIconValue(p.icon)
      return h(Original, { ...attrs, ...props, icon: normalizedIcon }, slots)
    }
  },
})

// Exportar set y aliases con el componente envuelto
export const mdi = { ...baseMdiSet, component: MdiSvgCompat } as any
export const aliases = baseAliases
